export interface CollectionPersistenceItem {
    Id: string | number;
    __isAdded?: boolean;
    __isChanged?: boolean;
    Deleted?: boolean;
}

/**
 * Detects a new item, including positive reference ids marked as added.
 * @param item Collection item to inspect.
 * @returns Whether the added flag is set or the id is negative.
 */
export const isAdded = (item: CollectionPersistenceItem): boolean =>
    Boolean(item.__isAdded) || Number(item.Id) < 0;

/**
 * Checks the item's explicit change flag without comparing its values.
 * @param item Collection item to inspect.
 * @returns Whether the item is marked as changed.
 */
export const isChanged = (item: CollectionPersistenceItem): boolean =>
    Boolean(item.__isChanged);

/**
 * Checks whether an item is marked for deletion.
 * @param item Collection item to inspect.
 * @returns Whether the deleted flag is set.
 */
export const isDeleted = (item: CollectionPersistenceItem): boolean =>
    Boolean(item.Deleted);

/**
 * Selects added, changed or deleted items for a save adapter.
 * @param item Collection item to inspect; nested changes must mark its container.
 * @returns Whether the item has pending persistence changes.
 */
export const hasPendingChanges = (item: CollectionPersistenceItem): boolean =>
    isAdded(item) || isChanged(item) || isDeleted(item);
